import "../../css/components/priority-messages.less";

export function initPriorityMessages(options = {}) {

    const settings = {
        debug: options.debug ?? false,
        priorityMessageKey: options.priorityMessageKey ?? "PoP-PriorityMessages",
        notificationMenuItemCss: options.notificationMenuItemCss ?? "notification-menu-item",
        messageCss: options.messageCss ?? "priority-message",
        closeBtnCss: options.closeBtnCss ?? "priority-message-close",
    };

    // Prevent duplicate binding if initPriorityMessages gets called more than once.
    // (Common when partial views / view components re-render.)
    if (window.__popPriorityMessagesInit) return;
    window.__popPriorityMessagesInit = true;

    init();
    initEvents();

    function log(message, object = null) {
        if (!settings.debug) return;

        if (message != null) console.log(message);
        if (object != null) console.log(object);
    }

    function init() {
        // check the session
        let messages = getMessagesFromStorage();

        // if no messages set yet, get from DOM
        if (messages == null) {
            log("messages is null, setting from DOM");

            messages = getMessagesFromDOM();
            setMessages(messages);
            displayMessages();
            displayCount(messages);

            return;
        }

        log("messages are not null, getting the rest", messages);

        // If messages have already been set:
        // - get current messages from DOM
        // - compare to get all messages not yet hidden (Display=false)
        const messagesFromDOM = getMessagesFromDOM();

        log("messages from DOM", messagesFromDOM);

        const activeMessages = compare(messagesFromDOM, messages);

        setMessages(activeMessages);
        displayMessages();
        displayCount(messagesFromDOM);
    }

    function initEvents() {
        initCloseButtons();
        initShowHideButton();
    }

    function displayCount(messagesFromDOM) {
        // update the count icon for all messages
        const count = messagesFromDOM.length > 0 ? messagesFromDOM.length : 0;

        log(`message count = ${count}`);

        if (count === 0) return;

        const notificationIcons = document.getElementsByClassName(settings.notificationMenuItemCss);

        const li = notificationIcons[0].closest("li");

        if (li) {
            li.style.display = "";
        }

        for (let i = 0; i < notificationIcons.length; i++) {

            notificationIcons[i].classList.add("active");

            const countElem = notificationIcons[i].getElementsByClassName("notification-count")[0];
            if (countElem) countElem.innerText = count;
        }
    }

    function displayMessages() {
        const messages = getMessagesFromStorage();
        const activeMessages = getActive(messages || []);

        if (!activeMessages || activeMessages.length === 0) return;

        log(`displaying messages ${activeMessages.length}`);

        for (let i = 0; i < activeMessages.length; i++) {
            show(activeMessages[i].Id);
        }
    }

    function initCloseButtons() {
        const closeBtns = document.getElementsByClassName(settings.closeBtnCss);

        for (let i = 0; i < closeBtns.length; i++) {
            const btn = closeBtns[i];

            // Ensure we don't double-bind if init runs more than once for some reason
            if (btn.dataset.popBound === "1") continue;
            btn.dataset.popBound = "1";

            btn.addEventListener(
                "click",
                function () {
                    const id = this.getAttribute("data-id");
                    hide(id);
                },
                false
            );
        }
    }

    function initShowHideButton() {
        const showHideBtns = document.getElementsByClassName(settings.notificationMenuItemCss);

        log("init show hide button for elements", showHideBtns);

        // get all messages - if any, add class "show" to menu
        const allMessages = getMessagesFromStorage() || [];
        let messages = getActive(allMessages);
        let showMenuItem = false;

        log("initShowHideButton - next, messages = ", messages);

        if (allMessages.length > 0) showMenuItem = true;

        for (let i = 0; i < showHideBtns.length; i++) {
            const showHideBtn = showHideBtns[i];

            log("individual show hide button", showHideBtn);

            if (showMenuItem) {
                showHideBtn.classList.add("show");
            }

            // Ensure we don't double-bind
            if (showHideBtn.dataset.popBound === "1") continue;
            showHideBtn.dataset.popBound = "1";

            showHideBtn.addEventListener("click", function () {
                // refresh from storage each click so state is always current
                const all = getMessagesFromStorage() || [];
                const active = getActive(all);
                messages = active;

                log("click event, messages", messages);

                if (messages.length > 0) {
                    log(`showing ${messages.length} active messages`);

                    // if there is more than 1 message showing, close them
                    // if there is only 1 message showing:
                    //   - if more than 1 total, show the others
                    //   - if only 1 total, toggle it (show -> hide) effectively means hide in this branch
                    if (messages.length > 1) {
                        log("more than 1 message");
                        for (let j = 0; j < messages.length; j++) {
                            hide(messages[j].Id);
                        }
                    } else {
                        log("only showing 1 message");
                        if (all.length > 1) {
                            for (let j = 0; j < all.length; j++) {
                                show(all[j].Id);
                            }
                        } else {
                            // one total, one active -> hide it (toggle behavior feels more natural)
                            hide(messages[0].Id);
                        }
                    }
                } else {
                    log("no active message, showing all");
                    showAllMessages();
                }
            });
        }
    }

    function showAllMessages() {
        const messages = getMessagesFromStorage() || [];
        log("showing all messages", messages);

        for (let i = 0; i < messages.length; i++) {
            show(messages[i].Id);
        }
    }

    function getMessage(id) {
        if (!id) return null;

        const message = document.querySelectorAll(`.${settings.messageCss}[data-id="${id}"]`)[0];

        log(`getting message by id - ${id}`, message);

        return message;
    }

    function show(id) {
        const elem = getMessage(id);

        if (!elem) return;

        log(`showing message for id ${id}`, elem);

        elem.classList.add("active");

        updateMessageStatus(id, true);
    }

    function hide(id) {
        const elem = getMessage(id);

        if (!elem) return;

        log(`hiding message for id ${id}`, elem);

        elem.classList.remove("active");

        updateMessageStatus(id, false);
    }

    function compare(messagesFromDOM, messagesFromStorage) {
        // DOM messages are active by default Display=true
        // storage messages have previous settings "Display=true/false"
        // goal is to combine objects to get intersection, preferring stored Display values
        const final = [];

        for (let i = 0; i < messagesFromDOM.length; i++) {
            const message = messagesFromDOM[i];
            let found = false;

            for (let j = 0; j < messagesFromStorage.length; j++) {
                const storedMessage = messagesFromStorage[j];

                if (storedMessage.Id === message.Id) {
                    final.push(storedMessage);
                    found = true;
                }
            }

            if (!found) {
                final.push(message);
            }
        }

        log("final compared object", final);

        return final;
    }

    function getActive(messages) {
        const allMessages = Array.isArray(messages) ? [...messages] : [];

        log(`filtering active ${allMessages.length}`, allMessages);

        const active = allMessages
            .map((message) => {
                if (message?.Display === true) return message;
                return undefined;
            })
            .filter((message) => message !== undefined)
            .map((message) => message);

        log("active messages", active);

        return active;
    }

    function getMessagesFromDOM() {
        const current = document.getElementsByClassName(settings.messageCss);
        const messages = [];

        for (let i = 0; i < current.length; i++) {
            const id = current[i].getAttribute("data-id");

            log(`current id = ${id}`);

            const obj = { Id: id, Display: true };
            messages.push(obj);
        }

        return messages;
    }

    function setMessages(messages) {
        log("Setting Messages", messages);

        // Keep the behavior from your original code (normalize through Object.keys),
        // but also handle real arrays cleanly.
        const myData = Array.isArray(messages)
            ? messages
            : Object.keys(messages || {}).map((key) => messages[key]);

        localStorage.setItem(settings.priorityMessageKey, JSON.stringify(myData));
    }

    function updateMessageStatus(id, display) {
        log(`Updating message status for Id = ${id}, changing display to ${display}`);

        const messages = getMessagesFromStorage() || [];
        const newMessages = [];

        for (let i = 0; i < messages.length; i++) {
            const message = messages[i];
            if (message.Id == id) {
                message.Display = display;
            }
            newMessages.push(message);
        }

        setMessages(newMessages);
    }

    function getMessagesFromStorage() {
        try {
            const raw = localStorage.getItem(settings.priorityMessageKey);
            const messages = raw ? JSON.parse(raw) : null;

            log("getting messages from storage", messages);

            return messages;
        } catch (e) {
            log("error parsing messages from storage", e);
            return null;
        }
    }
}
